module.exports = __webpack_public_path__ + "media/images/jacuzzi-885f00ec11d37831fcb337545b5b866b.svg";